import { useState } from "react";
import { speakFan, type LessonPlay } from "./copy";

export function useFanLesson() {
  const [play, setPlay] = useState<LessonPlay>("idle");
  const [heard, setHeard] = useState(false);
  const [spoken, setSpoken] = useState(false);
  const ready = heard && spoken;

  return {
    play,
    ready,
    listen() {
      setHeard(true);
      setPlay("listen");
      speakFan();
    },
    speak() {
      setSpoken(true);
      setPlay("speak");
    },
    finish() {
      if (!ready) return;
      setPlay("done");
    },
  };
}
